/**
 * What really happened on an LSA call, as the AI read it from the recording
 * (utils/callDisposition.js on the server; test/dispositions.test.js keeps the
 * two lists in step). No imports and only erasable types, so node --test loads it.
 */
export const DISPOSITIONS: Record<string, string> = {
  booked: "Booked",
  office_follow_up: "Office to call back",
  not_booked: "Not booked",
  service_not_provided: "Service not provided",
  out_of_area: "Out of service area",
  existing_customer: "Existing customer",
  spam: "Spam or wrong number",
  no_conversation: "No conversation",
};

/** Calls Google credits when they are rated in LSA. */
export const RATE_IN_LSA = ["service_not_provided", "out_of_area", "spam"];

export const dispositionLabel = (value: unknown): string | null =>
  value == null || value === "" ? null : DISPOSITIONS[String(value)] || String(value);
